import { SplitStatus, SwapAccountStatus } from "../models/Split";
import { isValidCPF } from "./validationDocument";

export const getGenericStatus = (genericStatus: string) => {
  const status = {
    PENDING: "Pendente",
    ACTIVE: "Ativa",
    INACTIVE: "Inativo",
    FAILED: "Falhou"
  }
  return status[genericStatus];
}
export const getGenericStatusColor = (genericStatus: string) => {
  const status = {
    PENDING: "#AD4E00",
    ACTIVE: "#33594D",
    INACTIVE: "#6E7A91",
    FAILED: "#8E1E1E"
  }
  return status[genericStatus];
}

export const getGenericStatusBackgroundColor = (genericStatus: string) => {
  const status = {
    PENDING: "##FFFBE6",
    ACTIVE: "#F6FFED",
    INACTIVE: "#EDF1F7",
    FAILED: "#FFF2E8"
  }
  return status[genericStatus];
}

export function getPeriodicity(type: string) {
  if (type === "MONTHLY") return "Mensal";
  if (type === "SEMESTER") return "Semestral";
  return "Anual";
}

export const getSplitStatus = (splitStatus: SplitStatus) => {
  const status = {
    PENDING: "Processando",
    ACTIVE: "Ativa",
    INACTIVE: "Inativo",
    FAILED: "Solicitação declinada"
  }
  return status[splitStatus];
}

export const getSplitBackgroundColor = (splitStatus: SplitStatus) => {
  const status = {
    PENDING: "##FFFBE6",
    ACTIVE: "#F6FFED",
    INACTIVE: "#EDF1F7",
    FAILED: "#FFF2E8"
  }
  return status[splitStatus];
}

export const getSplitColor = (splitStatus: SplitStatus) => {
  const status = {
    PENDING: "#AD4E00",
    ACTIVE: "#33594D",
    INACTIVE: "#6E7A91",
    FAILED: "#8E1E1E"
  }
  return status[splitStatus];
}

export const getSwapStatus = (splitStatus: SwapAccountStatus) => {
  const status = {
    PENDING: "Processando",
    ACTIVE: "Ativa",
    INACTIVE: "Inativo",
    BLOCKED: "Bloqueada",
    AWAITING_CLOSURE: "Aguardando encerramento",
    CLOSED: "Conta encerrada",
    FAILED: "Solicitação declinada"
  }
  return status[splitStatus];
}

export const getSwapBackgroundColor = (splitStatus: SwapAccountStatus) => {
  const status = {
    PENDING: "##FFFBE6",
    ACTIVE: "#F6FFED",
    INACTIVE: "#EDF1F7",
    FAILED: "#FFF2E8",
    CLOSED: "#FFF2E8",
    AWAITING_CLOSURE: "#FFF2E8",
    BLOCKED: "#FFF2E8"
  }
  return status[splitStatus];
}

export const getSwapColor = (splitStatus: SwapAccountStatus) => {
  const status = {
    PENDING: "#AD4E00",
    ACTIVE: "#33594D",
    INACTIVE: "#6E7A91",
    FAILED: "#8E1E1E",
    CLOSED: "#8E1E1E",
    AWAITING_CLOSURE: "#8E1E1E",
    BLOCKED: "#8E1E1E",
  }
  return status[splitStatus];
}

export const getSplitStatusButtonText = (splitStatus: SplitStatus) => {
  const status = {
    INACTIVE: "Solicitar ativação de conta",
    FAILED: "Reenviar cadastro"
  }
  return status[splitStatus];
}

export const getStatus = (status: string) => {
  const Status = {
    SCHEDULED: "Agendadas",
    CANCELED: "Canceladas",
    PAID: "Pago",
    PAID_MANUALLY: "Pago Manualmente",
    LATE: "Atrasado",
    ACTIVE: "Ativo",
    PENDING: "Pendente",
    AUTHORIZED: "Autorizado",
    FAILED: "Falha",
    INACTIVE: "Inativo",
    ABANDONED: "Desistência",
    DEFAULTER: "Inadimplente",
    CHARGEBACK: "Estornada",
  };
  //@ts-ignore
  return Status[status] || status;
};

export const getColorBadgeStatus = (status: string) => {
  const BadgeStatus = {
    SCHEDULED: "yellow",
    CANCELED: "lightred",
    PAID: "green",
    PAID_MANUALLY: "green",
    LATE: "yellow",
    ACTIVE: "lightgreen",
    PENDING: "yellow",
    AUTHORIZED: "blue",
    FAILED: "red",
    INACTIVE: "gray",
    ABANDONED: "volcano",
    DEFAULTER: "volcano",
    PROCESS_CANCEL: "lightred",
    SEND_INVOICE_SYSTEM: "yellow",
    SEND_AUTHORIZED: "yellow",
    PROCESS_AUTHORIZED: "yellow",
    CHARGEBACK: "yellow",
    CHARGEBACK_LIST: "yellowDark",
  };
  //@ts-ignore
  return BadgeStatus[status] || "gray";
};

export const getInvoiceStatus = (status: string) => {
  const Status = {
    AUTHORIZED: "Emitida",
    FAILED: "Erro",
    NOT_EMITTED: "Não Emitida",
    PROCESS_CANCEL: "Cancelamento em processo",
    CANCELED: "Cancelada",
    SEND_INVOICE_SYSTEM: "Emissão em processamento",
    SEND_AUTHORIZED: "Emissão em processamento",
    PROCESS_AUTHORIZED: "Emissão em processamento",
  };
  //@ts-ignore
  return Status[status] || "Não Emitida";
};

export const getPaymentMethod = (type: string) => {
  if (type === "CREDIT_CARD") return "Cartão de Crédito";
  if (type === "BANK_SLIP") return "Boleto";
  if (type === "PIX") return "Pix";
  return type;
};

export const getOperationMethod = (type?: string) => {
  if (type === "DEBIT_TRANSFER") return "Repasse";
  if (type === "INSTALLMENTS_ANTICIPATION") return "Parcela de antecipação";
  if (type === "DEBIT_CORRECTION") return "Correção";
  if (type === "CREDIT_CORRECTION") return "Correção";
  if (type === "FEE_DISCOUNT") return "Desconto em taxas";
  if (type === "REVENUE_ANTICIPATION") return "Antecipação de receita";
  return type;
}

export const getInitials = (value: string) => {
  if (value === "") {
    return "-";
  }
  const initials = value
    ?.split(" ")
    ?.map((w) => w[0])
    ?.join("")
    ?.substring(0, 2);
  return initials;
};

export const getTransferStatus = (type: string) => {
  const status = {
    AWAITING_AUTHORIZATION: "Aguardando autorização",
    HAS_FAIL: "Erro",
    PROCESSING: "Processando",
    SUCCESS: "Sucesso",
    CANCELED: "Cancelada",
    RETURNED: "Devolvido(a)"
  }
  return status[type];
}

export const getBackgroundColorForTransferStatus = (type: string) => {
  const status = {
    AWAITING_AUTHORIZATION: "#FFEDE3",
    HAS_FAIL: "#C42C2C1A",
    PROCESSING: "#FFEDE3",
    SUCCESS: "#C1C3D380",
    CANCELED: "#6E7A91"
  }
  return status[type];
}

export const getColorForTransferStatus = (type: string) => {
  const status = {
    AWAITING_AUTHORIZATION: "#AD4E00",
    HAS_FAIL: "#8E1E1E",
    PROCESSING: "#AD4E00",
    SUCCESS: "#4A6AA8",
    CANCELED: "#6E7A91"
  }
  return status[type];
}

export const getRateTypeValue = (type: string) => {
  const rateTypes = {
    percent: "Porcentagem",
    value: "Taxa fixa",
  }
  return rateTypes[type];
}


export function capitalizeFirstLetter(str) {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
}

export function formatWhiteLabelNames(str) {
  const whitelabels = {
    parcelamais: "Parcela mais",
    azp: "AZ Pague",
    flipsaude: "Quero flip",
    appbrlcard: "Brl",
    bsbpaycredit: "BSB Pay",
    bmhealthinvest: "BM Invest",
    stanleysveins: "Stanley's Veins"
  }
  return whitelabels[str] || capitalizeFirstLetter(str);
}

export function formatCep(cep: string) {
  const cepNumerico = cep.replace(/\D/g, '');
  if (cepNumerico.length !== 8) {
      return cep
  }
  const cepFormatado = `${cepNumerico.slice(0, 5)}-${cepNumerico.slice(5)}`;
  return cepFormatado;
}
export function formatPixKeyPlaceholders(type: string, value?: string) {
  const maskDocument = value ? isValidCPF(value) : false;
  const pixKeyPlaceholders: Record<string, string> = {
    EMAIL: "nome@empresa.com.br",
    PHONE: "(11) 99999-9999",
    CPF: "123.456.789-00",
    CNPJ: "01.123.456/0001-99",
    DOCUMENT: maskDocument ? "123.456.789-00" : "01.123.456/0001-99",
    ALLEATORY_KEY: "",
  };
  return pixKeyPlaceholders[type] ?? "Digite sua chave pix.";
}

export function formatPixKeyMasks(type: string, value?: string) {
  const maskDocument = value ? isValidCPF(value) : false;
  const pixKeyMasks: Record<string, string> = {
    EMAIL: "",
    ALLEATORY_KEY: "",
    PHONE: "cellphone",
    CPF: "cpf",
    CNPJ: "cnpj",
    DOCUMENT: maskDocument ? "cpf" : "cnpj",
  };
  return pixKeyMasks[type] ?? "";
}